"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectValidator = void 0;
const Validator_1 = require("../validator/Validator");
class ObjectValidator extends Validator_1.Validator {
    static isObject(value) {
        return typeof value === 'object' && value !== null && !Array.isArray(value);
    }
    static notEmpty(value) {
        return Object.keys(value).length > 0;
    }
    static hasKeys(value, keys) {
        return keys.every(key => key in value);
    }
    static objectContent(value, contentType) {
        return _a.isObject(value) && Object.values(value).every(item => typeof item === contentType);
    }
    static objectStructure(value, fieldsValidator) {
        return _a.isObject(value) && fieldsValidator.validate(value).isSuccess;
    }
    static noAdditionalKeys(value, keys) {
        return Object.keys(value).every(key => keys.includes(key));
    }
}
exports.ObjectValidator = ObjectValidator;
_a = ObjectValidator;
/**
 * Validates if the value is an object.
 */
ObjectValidator.IS_OBJECT = () => _a.validatorFactory('IS_OBJECT', _a.isObject);
/**
 * Validates if the object is not empty.
 */
ObjectValidator.NOT_EMPTY = () => _a.validatorFactory('NOT_EMPTY', _a.notEmpty);
/**
 * Validates if the object has specific keys.
 * @param keys - The keys that the object should have.
 */
ObjectValidator.HAS_KEYS = (keys) => _a.validatorFactory('HAS_KEYS', value => _a.hasKeys(value, keys));
/**
 * Validates the content types of the object.
 * @param contentType - The type of the content that the object should have.
 * @example
 * const ruleToValidate = ObjectValidator.OBJECT_CONTENT<string>('string');
 * const result = ruleToValidate.validator({ key1: 'value1', key2: 'value2' });
 * console.log(result); // true
 *
 * const invalidResult = ruleToValidate.validator({ key1: 'value1', key2: 2 });
 * console.log(invalidResult); // false
 */
ObjectValidator.OBJECT_CONTENT = (contentType) => _a.validatorFactory('OBJECT_CONTENT', value => _a.objectContent(value, contentType));
/**
 * Validates the structure of the object using a FieldsValidator.
 * @param fieldsValidator - The FieldsValidator to validate the object structure.
 * @example
 * class ExampleObjectValidator extends FieldsValidator<ExampleDto> {
 *   constructor() {
 *     super();
 *     this.validableFields = {
 *       id: FieldValidatorFactory.create<number>([NumberValidator.IS_NUMBER()]),
 *       name: FieldValidatorFactory.create<string>([StringValidator.IS_STRING()]),
 *       roles: FieldValidatorFactory.create<string[]>([ArrayValidator.NOT_EMPTY(), ArrayValidator.ARRAY_CONTENT('string')]),
 *     };
 *   }
 * }
 *
 * const ruleToValidate = ObjectValidator.OBJECT_STRUCTURE<ExampleDto>(new ExampleObjectValidator());
 * const result = ruleToValidate.validator({ id: 1, name: 'John Doe', roles: ['admin', 'user'] });
 * console.log(result); // true
 *
 * const invalidResult = ruleToValidate.validator({ id: '1', name: 'John Doe', roles: ['admin', 'user'] });
 * console.log(invalidResult); // false
 */
ObjectValidator.OBJECT_STRUCTURE = (fieldsValidator) => _a.validatorFactory('OBJECT_STRUCTURE', value => _a.objectStructure(value, fieldsValidator));
/**
 * Validates if the object has no additional keys other than the specified ones.
 * @param keys - The keys that the object should have.
 */
ObjectValidator.NO_ADDITIONAL_KEYS = (keys) => _a.validatorFactory('NO_ADDITIONAL_KEYS', value => _a.noAdditionalKeys(value, keys));
//# sourceMappingURL=ObjectValidator.js.map